/**
 * Sugerencias iniciales del asistente, según la pantalla donde se abre. Las específicas van
 * primero (máx. 2) y se completan con las generales hasta 4. Cada una tiene que poder
 * contestarse con la KB o con el catálogo de pantallas del BE (`psi-chat.destinations.ts`).
 */

const GENERAL_SUGGESTIONS = [
  "¿Cómo hablo de horarios con pacientes de otros países?",
  "¿Qué hago si el paciente no se conecta a la sesión?",
  "¿Cuál es el único medio permitido para contactar pacientes?",
  "¿Qué hago ante una urgencia o situación de riesgo?",
];

const MAX_SUGGESTIONS = 4;

/** Orden importa: gana la primera cuyo prefijo matchea (las más específicas primero). */
const SCREEN_SUGGESTIONS: { prefix: string; web: string[]; pwa?: string[] }[] = [
  {
    prefix: "/profile/metricas/liquidacion",
    web: ["¿Dónde veo el detalle de mi liquidación?", "¿Dónde cargo o cambio mis datos de pago?"],
  },
  {
    prefix: "/profile/metricas/psi-plus",
    web: ["¿Cómo se calcula el bono PSI+?", "¿Dónde veo los bonos de trimestres anteriores?"],
  },
  {
    prefix: "/profile/metricas",
    web: ["¿Dónde veo mi liquidación?", "¿Dónde veo el detalle de mis bonos PSI+?"],
  },
  {
    prefix: "/profile/vacaciones",
    web: ["¿Cómo cargo mis vacaciones o días off?", "¿Cómo cancelo unas vacaciones ya cargadas?"],
  },
  {
    prefix: "/profile",
    web: ["¿Dónde cargo mis vacaciones?", "¿Dónde veo mi liquidación?"],
  },
  {
    prefix: "/calendar",
    web: ["¿Cómo reprogramo una sesión?", "¿Cómo bloqueo un horario en mi agenda?"],
  },
  {
    prefix: "/sessions",
    web: ["¿Cómo ingreso a la sesión por Meet?", "¿Dónde veo el proceso de un paciente?"],
  },
  {
    prefix: "/patients",
    web: ["¿Cómo derivo a un paciente?", "¿Qué hago si un paciente no se puede agendar?"],
  },
  {
    prefix: "/comunidad",
    web: ["¿Dónde veo el calendario de formaciones?", "¿Dónde leo el newsletter?"],
    pwa: ["¿Dónde veo el calendario de formaciones?", "¿Dónde leo el newsletter?"],
  },
  {
    prefix: "/profile/notificaciones",
    web: [],
    pwa: ["¿Cómo activo las notificaciones en mi celular?"],
  },
  {
    // Inicio de la app mobile: la Agenda en solo lectura.
    prefix: "/",
    web: [],
    pwa: ["¿Dónde veo mis sesiones de hoy?", "¿Cómo reprogramo una sesión?"],
  },
];

export function getChatSuggestions(pathname: string, isPwa: boolean): string[] {
  const match = SCREEN_SUGGESTIONS.find(({ prefix }) =>
    prefix === "/" ? pathname === "/" : pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
  // Si la entrada no define sugerencias propias de la app mobile, valen las de la web (la pantalla existe en las dos).
  const specific = (isPwa ? (match?.pwa ?? match?.web) : match?.web) ?? [];
  return [...specific, ...GENERAL_SUGGESTIONS].slice(0, MAX_SUGGESTIONS);
}
